import React from 'react';
import { format } from 'date-fns';
import { STATUSES } from '../../data/mockData';

const fallbackType = { label: 'Appointment', color: '#6B7280' };
const fallbackStatus = { label: 'Unknown', color: '#6B7280' };

export default function AppointmentCard({ appointment, compact, onClick, typesMap = {} }) {
  const type = typesMap[appointment.type] || fallbackType;
  const status = STATUSES[appointment.status] || fallbackStatus;

  if (compact) {
    return (
      <button
        className="flex items-center gap-1.5 w-full h-full px-2 py-1 rounded-md cursor-pointer transition-all hover:brightness-110 text-left font-[inherit] text-white text-[10px] overflow-hidden"
        style={{ background: type.color, borderLeft: `3px solid ${type.color}dd` }}
        onClick={() => onClick(appointment)}
      >
        <span className="font-semibold opacity-90 whitespace-nowrap">{format(appointment.start, 'h:mm')}</span>
        <span className="font-semibold truncate">{appointment.client.name}</span>
        {appointment.is_collaborator && <span className="ml-auto text-[8px] opacity-70">Partner</span>}
      </button>
    );
  }

  return (
    <button
      className={`flex flex-col w-full p-2.5 bg-elevated border border-theme rounded-[10px] cursor-pointer transition-all hover:bg-hover-surface hover:shadow-lg hover:-translate-y-0.5 text-left font-[inherit] text-[inherit] text-primary-c min-h-full ${appointment.is_collaborator ? 'border-l-0' : ''}`}
      style={{ borderLeftWidth: 3, borderLeftColor: appointment.is_collaborator ? '#223368' : type.color }}
      onClick={() => onClick(appointment)}
    >
      <div className="flex items-center gap-1.5 mb-2">
        <span className="text-[10px] font-semibold px-2 py-[3px] rounded-full text-white" style={{ background: type.color }}>
          {type.label}
        </span>
        <span className="text-[10px] font-semibold px-2 py-[3px] rounded-full text-white" style={{ background: status.color }}>
          {status.label}
        </span>
        {appointment.is_collaborator && (
          <span className="text-[9px] font-bold px-2 py-[3px] rounded-full text-white bg-[#223368]">
            Partner
          </span>
        )}
      </div>
      <div className="flex flex-col gap-0.5">
        <div className="text-[11px] font-semibold text-secondary-c">
          {format(appointment.start, 'h:mm a')} — {format(appointment.end, 'h:mm a')}
        </div>
        <div className="text-[13px] font-bold tracking-tight">{appointment.client.name}</div>
        <div className="text-[11px] text-muted-c flex items-center gap-1 flex-wrap">
          <span>{appointment.staff.name}</span>
          <span className="opacity-40">·</span>
          <span>{appointment.location}</span>
        </div>
        {appointment.is_collaborator && appointment.owning_org && (
          <div className="text-[10px] text-[#223368] font-medium mt-0.5">
            via {appointment.owning_org.name}
          </div>
        )}
      </div>
    </button>
  );
}
